import React from "react";

// Import as React components via ?react (lowercase filenames)
import Settings from "@/assets/icons/atlas/settings.svg?react";
import User from "@/assets/icons/atlas/user.svg?react";
import Message from "@/assets/icons/atlas/message.svg?react";
import Search from "@/assets/icons/atlas/search.svg?react";
import Heart from "@/assets/icons/atlas/heart.svg?react";
import Location from "@/assets/icons/atlas/location.svg?react";
import Bug from "@/assets/icons/atlas/bug.svg?react";
import Home from "@/assets/icons/atlas/home.svg?react";
import Share from "@/assets/icons/atlas/share.svg?react";
import Trades from "@/assets/icons/atlas/trades.svg?react";
import Social from "@/assets/icons/atlas/social.svg?react";
import Events from "@/assets/icons/atlas/events.svg?react";
import Community from "@/assets/icons/atlas/community.svg?react";

// Optionally, ensure registry includes Trade
export const icons = {
  Home,
  Share,
  Trades,
  Settings,
  User,
  Message,
  Search,
  Heart,
  Location,
  Bug,
  Social,
  Events,
  Community
} as const;

export type IconName = keyof typeof icons;

export const ICONS: Record<IconName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  settings: Settings,
  user: User,
  message: Message,
  search: Search,
  heart: Heart,
  location: Location,
  trades: Trades,
  bug: Bug,
  home: Home,
  share: Share,
  social: Social,
  events: Events,
  community: Community
};
